import React, {useEffect, useRef} from 'react';
import {Fade} from '@mui/material';
import {Box, style} from '@mui/system';
import {FEATURE_ID} from '@/views/content-studio/constants';
import onboardingWizardStore from '../../onboardingWizardStore';
import getFeatureInfo from './getFeatureInfo';

const UNSELECTED_FEATURE_ID = 'unselected';
const UNSELECTED_FEATURE_ASSET =
  'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Unselected.mp4';

const videoBoxProps = {
  autoPlay: true,
  loop: true,
  muted: true,
  sx: {
    position: 'absolute',
    top: 0,
    left: 0,
    objectFit: 'cover',
  },
  style: {
    width: '100%',
    height: '100vh',
  },
};
function FeatureSelectionAssetDisplay() {
  const {hoveredFeature, selectedFeature} = onboardingWizardStore();

  const featureToDisplay =
    hoveredFeature ?? selectedFeature ?? UNSELECTED_FEATURE_ID;
  const videoRefs = useRef<{[key: string]: HTMLVideoElement | null}>({});

  useEffect(() => {
    if (featureToDisplay && videoRefs.current[featureToDisplay]) {
      const video = videoRefs.current[featureToDisplay];
      if (video) {
        video.currentTime = 0;
      }
    }
  }, [featureToDisplay]);

  return (
    <Box
      width="100%"
      height="100vh"
      sx={{backgroundColor: '#E5E3F4'}}
      display="flex"
      justifyContent="center"
      alignItems="center"
      position="relative"
    >
      {Object.values(FEATURE_ID).map((featureId) => (
        <Fade in={featureId === featureToDisplay} key={featureId} timeout={300}>
          <Box
            component="video"
            {...videoBoxProps}
            ref={(el) => {
              videoRefs.current[featureId] = el as HTMLVideoElement | null;
            }}
            src={getFeatureInfo(featureId).asset}
          />
        </Fade>
      ))}
      <Fade in={UNSELECTED_FEATURE_ID === featureToDisplay} timeout={300}>
        <Box
          component="video"
          ref={(el) => {
            videoRefs.current[UNSELECTED_FEATURE_ID] =
              el as HTMLVideoElement | null;
          }}
          src={UNSELECTED_FEATURE_ASSET}
          {...videoBoxProps}
        />
      </Fade>
    </Box>
  );
}

export default FeatureSelectionAssetDisplay;
